import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { TraitEntry } from '../../services/customerService';

/**
 * One inferred customer property.
 *
 * Deliberately styled as a *hint*, not as data the salon entered: the sparkle
 * icon and the tooltip naming the service it was read from are what keep the
 * distinction visible. A trait that looks like a stated fact would be worse
 * than no trait at all — the salon has to be able to tell the two apart before
 * it acts on them.
 */
export default function TraitChip({
  trait,
  className,
}: {
  trait: TraitEntry;
  className?: string;
}) {
  const label = trait.label || trait.trait;
  const value = trait.value_label || trait.value;
  const source = trait.from_item_nm
    ? `Abgeleitet aus der gebuchten Leistung „${trait.from_item_nm}“`
    : 'Abgeleitet aus gebuchten Leistungen';

  return (
    <span
      title={source}
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-border/70 bg-muted/50',
        'px-2 py-0.5 text-xs text-muted-foreground',
        className,
      )}
    >
      <Sparkles className="h-3 w-3 opacity-50" aria-hidden />
      <span className="text-foreground/80">{label}:</span>
      <span className="font-medium text-foreground">{value}</span>
    </span>
  );
}
